import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getUsersList = (page, pagesize, search, ordering, superuser) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/users/?superuser=${superuser}`, {
        headers: authHeader(),
        params: {
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search, // You might want to include search here, if applicable
            ordering: ordering,
            superuser: superuser,
        },
    });
};

const getUsersPermissionList = (user_id) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/get-all-permission-list/?user_id=${user_id}`, {
        headers: authHeader(),
    });
};
const getArchiveUsersList = (page, pagesize, search, ordering) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/users/?deleted=1`, {
        headers: authHeader(),
        params: {
            page: page,
            pagesize: pagesize,
            search: search, // You might want to include search here, if applicable
            ordering: ordering
        },
    });
};
const getUserById = (id) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/users/${id}`, { headers: authHeader() });
};
const createUser = (payload) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/users/`,
        payload, // Payload for the request body
        {
            headers: {
                ...authHeader(),
                'Content-Type': 'multipart/form-data',
            }
        },
    );
};
const createPassword = (payload) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/user-password-change/`,
        payload, // Payload for the request body

        { headers: authHeader() },

    );
};
const changePassword = (payload) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/user-password-change/change-password/`,
        payload, // Payload for the request body
        {
            headers: {
                'Content-Type': 'application/json',
            }
        },
    );
};
const updateUser = (id, formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/users/${id}/`, // Include the die group's ID in the URL
        formPayload, // Payload for the request body
        {
            headers: {
                ...authHeader(),
                'Content-Type': 'multipart/form-data',
            }
        },
    );
};
const updateUserStatus = (payload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/users/user-status-change/`, // Include the die group's ID in the URL
        payload, // Payload for the request body
        { headers: authHeader() }
    );
};
const archiveUser = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/users/${id}/archive/`, // Include the die group's ID in the URL
        {},
        { headers: authHeader() } // Authentication header
    );
};
const unArchiveUser = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/users/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const userService = {
    getUsersList,
    getArchiveUsersList,
    getUserById,
    createUser,
    updateUser,
    createPassword,
    changePassword,
    updateUserStatus,
    archiveUser,
    unArchiveUser,
    getUsersPermissionList
};

export default userService;
